module.exports = "searchdiv {\r\n  height: 200px;\r\n}\r\n"